document.querySelectorAll("[data-toggle-target]").forEach((el) => {
  el.addEventListener("click", (ev) => {
    const preventDefault = el.getAttribute("data-prevent-default")
    if (preventDefault !== "false") {
      ev.preventDefault()
    }

    const targetSelector = el.getAttribute("data-toggle-target")
    const classToApplyOnToggle = el.getAttribute("data-class-to-toggle") || "js-hidden"
    if (targetSelector) {
      const targets = document.querySelectorAll(targetSelector)
      for (const t of targets) {
        t.classList.toggle(classToApplyOnToggle)
      }
    }
  })
})
